module.exports = __webpack_public_path__ + "img/jydt.27b3fca7.png";